import React,{useState} from 'react';
export default function Symptoms(props) {
  const {msg,setSymptom,symptom,value,color,img } = props;
  return (
    <>
       
        <button onClick={()=>setSymptom(value[0])} style={{backgroundColor:color}} 
        className={`text-center relative shadow p-3 px-5 rounded-2xl inline-block mr-2 my-1 border-2 ${(value[0]==symptom)? 'border-blue-700 ':'border-transparent' }`}>
            {(value[0]==symptom)&&
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="white" 
            className="w-5 h-5 absolute right-1 -top-2 bg-primary p-0.5 rounded-full border-2 border-white">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
}
           {value[1]&&  <img src={value[1]} className="h-7 mr-2 inline-block"/>  }
            <span className=''>{value[0]}</span>              
        </button>
    </>
  );
}